import script from "./MRadioGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./MRadioGroup.vue?vue&type=script&setup=true&lang=js"

import "./MRadioGroup.vue?vue&type=style&index=0&id=0b58cce6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b58cce6"]])

export default __exports__